module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/L1qYli/tc-custom/9781423609520.jpg?1736951421305",
      "alt": "This image is the cover for the book Don't Squat With Your Spurs On, Volume No. 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Don't Squat With Your Spurs On, Volume No. 2\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("More Western wit, wisdom, and words to live by!")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Whether the glass is half empty or half full depends on whether you’re drinking or pouring.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("A stranger’s business ain’t yours.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("We might not be so bad off if we had a little less of everything.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Henry Ward Beecher said “the common sense of one century is the common sense of the next.” This follow-up the multimillion-selling collection of cowboy wit and wisdom shares the sorts of sayings and observations that get handed down from generation to generation—and that provide not only belly laughs but plenty of sage advice.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Texas Bix Bender\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0